import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid2";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { Box } from "@mui/system";

type Props = {
  requestID: string;
  comment: string;
  reason: string;
  requestTitle: string;
  setComment: (comment: string) => void;
  setReason: (reason: string) => void;
};

export default function StepEscalate({ comment, setComment, reason, setReason, requestID, requestTitle }: Props) {
  return (
    <Box>
      <DialogTitle>
        Escalate request #{requestID} | {requestTitle}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>Please fill in the reason for escalation</DialogContentText>

        <Grid
          container
          spacing={2}
          sx={{
            mt: 0,
          }}
        >
          <Grid size={12}>
            <TextField
              data-cy={"select-reason"}
              id="reason"
              name="reason"
              label="Escalation Reason"
              required
              variant="outlined"
              value={reason}
              onChange={(event) => {
                setReason(event.target.value);
              }}
              select
              fullWidth
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
            >
              <MenuItem value="time">Long resolution time</MenuItem>
              <MenuItem value="business">Business Impact</MenuItem>
              <MenuItem value="technical">Technical expertise</MenuItem>
              <MenuItem value="avaResponseNotSufficient">Ava's answer was insufficient</MenuItem>
              <MenuItem value="other">Other</MenuItem>
            </TextField>
          </Grid>
          <Grid size={12}>
            <TextField
              data-cy="comment"
              id="comment"
              name="comment"
              label="Add Comment"
              variant="outlined"
              value={comment}
              onChange={(event) => {
                setComment(event.target.value);
              }}
              multiline
              rows={3}
              maxRows={3}
              fullWidth
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Box>
  );
}
